import { Component, Injector, OnInit } from '@angular/core';
import { ApAlertService } from 'webcommon/core-ui';
import { FcFilterConfigurationFieldType, FcGenericFilterModalBaseComponent } from '../../generic';
import { FormControl, FormGroup } from '@angular/forms';
import { DrugListFilterFormColumnName, DrugListFilterFormType } from 'webcommon/shared';

@Component({
  selector: 'fc-drug-list-filter-modal',
  providers: [ApAlertService],
  templateUrl: './fc-drug-list-filter-modal.component.html',
})
export class FcDrugListFilterModalComponent extends FcGenericFilterModalBaseComponent implements OnInit {

  public override baseId = 'fc-drug-list-filter';

  public form = new FormGroup<DrugListFilterFormType>({
    drug: new FormControl<string | null>(null),
    includeBrandName: new FormControl<string>('true'),
    includeGenericName: new FormControl<string>('true'),
    includeMedicalDevices: new FormControl<string>('false'),
  });

  protected checkBoxControlsList = [
    {
      label: 'Include Brand Name', controlName: 'includeBrandName',
    },
    {
      label: 'Include Generic Name', controlName: 'includeGenericName',
    },
    {
      label: 'Include Medical Devices', controlName: 'includeMedicalDevices',
    },
  ];

  constructor(
    protected injector: Injector,
  ) {
    super(injector);
    this._setFormControlsConfig();
  }

  private _setFormControlsConfig(): void {
    this.config.set(DrugListFilterFormColumnName.DrugName, {
      type: FcFilterConfigurationFieldType.Single,
      control: this.form.controls.drug,
    });

    this.config.set(DrugListFilterFormColumnName.IncludeBrandName, {
      type: FcFilterConfigurationFieldType.Single,
      control: this.form.controls.includeBrandName,
    });

    this.config.set(DrugListFilterFormColumnName.IncludeGenericName, {
      type: FcFilterConfigurationFieldType.Single,
      control: this.form.controls.includeGenericName,
    });

    this.config.set(DrugListFilterFormColumnName.IncludeMedicalDevice, {
      type: FcFilterConfigurationFieldType.Single,
      control: this.form.controls.includeMedicalDevices,
    });

  }

  override ngOnInit(): void {
    super.ngOnInit();
  }


  public override onClear(): void {
    this.form.controls.drug.reset();
  }



}

